import styled from 'styled-components'

export const GroupsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 26px;
`
